<div class="text-color-neutral-darkest">{{ 'payroll.benefitTaxation.employeePremium' | translate }}</div>
<div class="app-grid margin-top-2">
    <div class="columns-8">{{ 'payroll.benefitTaxation.income' | translate }}</div>
    <div class="columns-4 text-color-primary">
        {{ (benefitType?.pretax ? 'payroll.benefitTaxation.preTax' : 'payroll.benefitTaxation.postTax') | translate }}
    </div>
</div>
<div class="margin-top-3 text-color-neutral-darkest">
    {{ 'payroll.benefitTaxation.companyContribution' | translate }}
</div>
<div class="app-grid margin-top-2">
    <div class="columns-8">{{ 'payroll.benefitTaxation.incomeTax' | translate }}</div>
    <div class="columns-4 text-color-primary">{{ benefitType?.taxable ? '✔' : '' }}</div>
</div>
<div class="app-grid margin-top-2">
    <div class="columns-8">{{ 'payroll.benefitTaxation.incomeTaxQc' | translate }}</div>
    <div class="columns-4 text-color-primary">{{ benefitType?.qcTaxable ? '✔' : '' }}</div>
</div>
<div class="app-grid margin-top-1">
    <div class="columns-8">{{ 'payroll.benefitTaxation.cpp' | translate }}</div>
    <div class="columns-4 text-color-primary">{{ benefitType?.pensionable ? '✔' : '' }}</div>
</div>
<div class="app-grid margin-top-1">
    <div class="columns-8">{{ 'payroll.benefitTaxation.qpp' | translate }}</div>
    <div class="columns-4 text-color-primary">{{ benefitType?.qcPensionable ? '✔' : '' }}</div>
</div>
<div class="app-grid margin-top-1">
    <div class="columns-8">{{ 'payroll.benefitTaxation.ei' | translate }}</div>
    <div class="columns-4 text-color-primary">{{ benefitType?.insurable ? '✔' : '' }}</div>
</div>
<div class="app-grid margin-top-2">
    <div class="columns-8">{{ 'payroll.benefitTaxation.wcb' | translate }}</div>
    <div class="columns-4 text-color-primary">{{ benefitType?.assessable ? '✔' : '' }}</div>
</div>
<div class="margin-top-3 text-color-neutral-darkest">{{ 'payroll.benefitTaxation.roe' | translate }}</div>
<div class="app-grid margin-top-2">
    <div class="columns-8">{{ 'payroll.benefitTaxation.insurableEarnings' | translate }}</div>
    <div class="columns-4">{{ benefitType?.roeEarnings ? '✔' : '' }}</div>
</div>
<div class="margin-top-3 text-color-neutral">{{ 'payroll.benefitTaxation.taxForms' | translate }}</div>
<div class="app-grid margin-top-2">
    <div class="columns-8">{{ 'payroll.benefitTaxation.t4Boxes' | translate }}</div>
    <div class="columns-4">{{ benefitType?.t4BoxesDisplayList }}</div>
</div>

<ng-container *ngIf="qcPayrollFeatureFlag">
    <div class="app-grid margin-top-2">
        <div class="columns-8">{{ 'payroll.benefitTaxation.rl1Boxes' | translate }}</div>
        <div class="columns-4">{{ benefitType?.rl1BoxesDisplayList }}</div>
    </div>
</ng-container>
